import { render, staticRenderFns } from "./NavMobileMarketing.vue?vue&type=template&id=45b56202&scoped=true&"
import script from "./NavMobileMarketing.vue?vue&type=script&lang=js&"
export * from "./NavMobileMarketing.vue?vue&type=script&lang=js&"
import style0 from "./NavMobileMarketing.vue?vue&type=style&index=0&id=45b56202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b56202",
  null
  
)

export default component.exports